import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppMain from "./components/AppMain";
import { pmsCodes } from '@/enum';
import { filterPms } from '@/utils/pms';
import LocalesSwitcher from '@/components/LocalesSwitcher';
import ChangePasswordModal from '@/components/ChangePasswordModal';
import { changeLang } from '@/utils/lang';
export default {
  name: 'Index',
  components: {
    LocalesSwitcher: LocalesSwitcher,
    AppMain: AppMain,
    ChangePasswordModal: ChangePasswordModal
  },
  data: function data() {
    var _this = this;
    return {
      mobileMenuShowing: false,
      mobileLangValue: '',
      changePasswordVisible: false,
      bindMenus: [],
      menus: [{
        id: 'card',
        path: '/card',
        iconClass: 'iconqianbao1',
        label: this.$t('router.card'),
        pms: pmsCodes.card
      }, {
        id: 'wallet',
        path: '/wallet',
        iconClass: 'iconqianbao1',
        label: this.$t('router.wallet'),
        pms: pmsCodes.wallet
      }, {
        id: 'finance',
        path: '/finance',
        iconClass: 'iconjijin',
        label: this.$t('router.finance'),
        pms: [pmsCodes.finance, pmsCodes.npayFinance]
      }, {
        id: 'settings',
        path: '/settings',
        iconClass: 'iconjijin',
        label: this.$t('settings.title'),
        pms: [pmsCodes.openApiConfig, pmsCodes.openApiConfig]
      }],
      userControlMenu: [
      // {
      //   id: 'account',
      //   label: this.$t('personal'),
      //   onClick: () => {
      //     this.go2Account()
      //   }
      // },
      {
        id: 'changePassword',
        label: this.$t('changePassword.title'),
        onClick: function onClick() {
          console.log('changePasswordVisible', _this.changePasswordVisible);
          _this.changePasswordVisible = true;
        }
      }, {
        id: 'logout',
        label: this.$t('logout'),
        onClick: function () {
          var _onClick = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.$store.dispatch('user/logout');
                case 2:
                  _this.$router.push("/login");
                case 3:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function onClick() {
            return _onClick.apply(this, arguments);
          }
          return onClick;
        }()
      }]
    };
  },
  computed: {
    selected: function selected() {
      return this.$route.matched[0].path;
    },
    user: function user() {
      return this.$store.state.user;
    }
  },
  mounted: function mounted() {
    this.initMenu();
  },
  methods: {
    go2Account: function go2Account() {
      var url = this.$router.resolve('/account');
      window.open(url.href, '_blank');
    },
    handleSelectMenu: function handleSelectMenu(menu) {
      var isMobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.selected === menu.path) {
        return;
      }
      this.$router.push(menu.path);
      if (isMobile && this.$refs.mobileMenu) {
        this.$refs.mobileMenu.close();
      }
    },
    logout: function () {
      var _logout = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.$store.dispatch('user/logout');
            case 2:
              this.$router.push('/login');
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }(),
    initMenu: function initMenu() {
      this.bindMenus = filterPms(this.menus);
      if (this.$route.path === '/layout' && this.bindMenus.length > 0 && this.bindMenus[0].path) {
        this.$router.push(this.bindMenus[0].path);
      }
    },
    mobileLangSelectChangeHandler: function mobileLangSelectChangeHandler(e) {
      var locale = e.target.value;
      if (!locale) {
        return;
      }
      changeLang(locale);
    }
  }
};